import Script from 'next/script';

export default function FourEyesScript() {
  return (
    <Script
      src="https://scripts.foureyes.io/fe-init.js"
      strategy="afterInteractive"
    />
  );
}
